import {TextComponent} from '../text/TextComponent'

class UnsupportedTextComponent extends TextComponent {
    render($$) {
        return super.render($$, {
            textClassName: 'dw-unsupported-text',
            labelClassName: '',
            shortLabel: '?',
            longLabel: 'Unsupported text'
        })
    }
}

export {UnsupportedTextComponent}
